import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/resource/:resourceId',
      name: 'resource',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Resource.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      beforeEnter: (to, from, next) => {
        // only route to settings page when logged in
        next(store.state.isSignedIn)
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
    },
  ]
})

let autoJumpToDefaultRoomTimer = null
router.beforeResolve((to, from, next) => {
  if (store.state.settings.autoJumpToDefaultRoom &&
    store.state.settings.defaultResourceId) {
    clearTimeout(autoJumpToDefaultRoomTimer)
    if (to.path !== 'resource' || (to.path === 'resource' && to.params.resourceId !== store.state.settings.defaultResourceId)) {
      autoJumpToDefaultRoomTimer = setTimeout(function () {
        router.replace({ name: 'resource', params: { resourceId: store.state.settings.defaultResourceId } })
        console.log('Auto jump back to room', store.state.settings.defaultResourceId)
      }, parseInt(store.state.settings.defaultViewTimeout) * 1000)
    }
  }
  next()
})

export default router
